import styled, { css } from "styled-components";
import colours from "assets/colours";
import queries, { minQuery, devices } from "utils/responsivenessHelper";
import { menuWidth, headerHeight } from "constants/layout";
import zIndex from "constants/zIndex";
import { styledScroll } from "components/shared/layout";

const UserName = styled.div`
  color: ${colours.zltoLightBlue};
  font-size: 1.5rem;
  line-height: 166%;
  font-weight: 600;
`;

const ProfilePictureWrapper = styled.div`
  border-radius: 100%;
  box-shadow: 7.28px 7.28px 39.312px rgba(108, 109, 133, 0.25);
  position: relative;
  display: flex;
  width: 96px;
  height: 96px;
  justify-content: center;
  align-items: center;
`;

const IconWrapper = styled.div`
  background: ${colours.white};
  position: absolute;
  right: 0;
  bottom: 0;
  padding: 8px;
  border-radius: 100%;
  height: 30px;
  width: 30px;
  box-shadow: 7.28px 7.28px 39.312px rgba(108, 109, 133, 0.25);
`;

const AddIcon = styled.img``;

const LocationRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 166%;
  color: ${colours.zltoLightBlue};

  img {
    margin-right: 8px;
  }
`;

const ActionsRow = styled.div`
  width: 100%;
  padding: 36px 0px 5px 0px;
`;

const UserInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0px 25px;
`;

const MenuDivider = styled.hr`
  width: 270px;
  height: 0px;
  background: ${colours.zltoLightBlue};
  border: 0.1px solid ${colours.zltoLightBlue};
  margin: 0 auto;

  ${queries.both({
    borderWidth: "0.1px",
  })}
`;

const Logo = styled.img`
  cursor: pointer;
  position: absolute;
  margin-top: 50px;
`;

const LogoContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: ${headerHeight};
`;

const Container = styled.div`
  background: ${colours.zltoDarkBlue};
  box-shadow: 10px 10px 54px rgba(108, 109, 133, 0.11);
  z-index: ${zIndex.sideMenu};
  position: fixed;
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;

  ${({ mobile, navOpen }) => {
    if (!mobile) {
      return css`
        margin-left: -${menuWidth};
        left: ${menuWidth};
        width: ${navOpen ? menuWidth : 0};
      `;
    } else {
      return css`
        transition: all 0.5s ease;
        margin-right: -250px;
        right: 250px;
        width: ${navOpen ? "250px" : 0};

        ${minQuery.both(
          {
            marginRight: `-${menuWidth}`,
            right: menuWidth,
            width: navOpen ? menuWidth : 0,
          },
          null,
          devices.iPad
        )}
      `;
    }
  }}

  ${styledScroll};
`;

export {
  Container,
  LogoContainer,
  Logo,
  MenuDivider,
  UserInfoContainer,
  ActionsRow,
  LocationRow,
  UserName,
  ProfilePictureWrapper,
  AddIcon,
  IconWrapper,
};
